import React from 'react';

const ViewCompletedButton = () => {
  return (
    <button className="goal-button">
      View Completed
    </button>
  )
};
export default ViewCompletedButton;